/*
* Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
* This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
* The receipt or possession of this program does not convey any rights to use, reproduce or disclose
* its contents in whole or in part, without the specific written consent of Inovalon, Inc.
* Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
* is a violation of the copyright laws and may subject you to criminal prosecution.
*/
import { AxiosError } from 'axios'

/**
 * the class for the singleton ErrorHelper instance
 *
 * @class ErrorHelper
 */
export class ErrorHelper {
	static handleApiError(error: AxiosError): void {
		if (error.response !== null && typeof error.response !== 'undefined' && error.response.status === 401) {
			alert('Your session has expired')
			window.location.href = '/'
		} else {
			throw error
		}
	}
}
